module.exports = __webpack_public_path__ + "media/facebook.3ad226f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/coffee/assets/facebook.svg
// module id = ./src/templates/coffee/assets/facebook.svg
// module chunks = 0